import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { IconsRegistry } from '@seu-services';
import { completeIconSet } from '@seu-types';
import { Subscription } from 'rxjs';

@Component({
  selector: 'seu-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [RouterOutlet],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit, OnDestroy {
  private readonly iconRegistry = inject(IconsRegistry);
  private readonly authService = inject(MsalService);

  private readonly subscriptions = new Subscription();

  ngOnInit(): void {
    this.init();
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  private async init(): Promise<void> {
    this.iconRegistry.registerIcons(completeIconSet);
    this.initMsal();
  }

  private initMsal(): void {
    this.subscriptions.add(
      this.authService.handleRedirectObservable().subscribe()
    );
  }
}
